import { FeatureKey, FeatureModule } from '~/modules/feature-access/policy';
import { useAppSelector } from '~/store/hooks/useAppSelector';

export const useFeatureAccess = (): {
  getFeatureAccess: (module: FeatureModule, key: FeatureKey) => boolean;
} => {
  const features = useAppSelector(
    (state) => state.profile.user_policy?.features,
  );

  const getFeatureAccess = (
    module: FeatureModule,
    key: FeatureKey,
  ): boolean => {
    // `?? true` тут був недосяжний: `!!x` ніколи не nullish, тому fallback не
    // виконувався ніколи. Поведінка збережена як є — коли policy ще не
    // завантажена, доступ вважається закритим.
    return !!features?.[module]?.[key];
  };

  return { getFeatureAccess };
};
